import React, { useEffect, useState } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import enhancer from "./enhancer/EditProfileEnhancer";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

import NavigationActions from "redux/navigation/actions";
import Loader from "components/Loader";
import {
  getMerchantProfile,
  editMerchantProfile
} from "services/merchantProfileServices";
import { useFormikContext } from "formik";
import { XCircle } from "react-feather";
import { useRef } from "react";
import authActions from "redux/auth/actions";
const { login, setUser } = authActions;
const { success, error } = NavigationActions;

const EditProfile = props => {
  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    errors,
    touched,
    submitCount,
    token,
    setValues,
    isValid,
    user
  } = props;
  const [loading, setLoading] = useState(false);
  let [oldImage, setOldImage] = useState("");
  let [newImage, setNewImage] = useState("");
  const formik = useFormikContext();
  let fileRef = useRef("");

  useEffect(() => {
    user && getProfile();
  }, [user]);

  const getProfile = async () => {
    await getMerchantProfile(token, user._id).then(res => {
      if (res.success) {
        setValues({
          name: res?.data?.name,
          email: res?.data?.email,
          phone_number: res?.data?.phone_number,
          file_image: res?.data?.file_image
        });
        setOldImage(res?.data?.file_image);
      } else {
        error(res.message);
      }
    });
  };
  function deleteImage(type) {
    fileRef.current.value = "";
    if (type === "new") {
      setNewImage("");
    } else {
      setOldImage("");
    }
    setValues({ ...values, file_image: "" });
  }
  function handleImageChange(e) {
    setValues({ ...values, file_image: e.target.files[0] });
    setNewImage(e.target.files[0]);
    if (oldImage) {
      setOldImage("");
    }
  }

  const submitHandler = async event => {
    event.preventDefault();
    handleSubmit();
    const formData = new FormData();
    formData.append("name", values.name);
    formData.append("email", values.email);
    formData.append("phone_number", values.phone_number);
    if (!values.file_image) {
      formData.append("file_image", "");
    } else {
      formData.append("file_image", values.file_image);
    }
    if (isValid) {
      setLoading(true);
      await editMerchantProfile(token, user._id, formData).then(res => {
        if (res.success) {
          success(res.message);
          props.setUser(res?.data);
          getProfile();
          setNewImage("");
          props.history.push("/profile");
          setLoading(false);
        } else {
          error(res.message);
          setLoading(false);
        }
      });
    }
  };

  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };

  return (
    <div className="work-card">
      <h4>Profile Information</h4>
      <div className="work-body mt-4">
        <form onSubmit={submitHandler}>
          <div className="row login-box p-0 w-100">
            <div className="col-12 col-sm-7">
              <div className="form-group">
                <label>Name</label>
                <input
                  type="text"
                  className="form-control react-form-input"
                  id="name"
                  onChange={handleChange}
                  value={values.name}
                  onBlur={handleBlur}
                  placeholder="Merchant Name"
                />
                <Error field="name" />
              </div>
            </div>
            <div className="col-12 col-sm-7">
              <div className="form-group">
                <label>Email</label>
                <input
                  type="text"
                  className="form-control react-form-input"
                  id="email"
                  onChange={handleChange}
                  value={values.email}
                  onBlur={handleBlur}
                  placeholder="Merchant Email"
                  disabled
                />
                <Error field="email" />
              </div>
            </div>
            <div className="col-12 col-sm-7">
              <div className="form-group">
                <label>Phone Number</label>
                <input
                  type="text"
                  className="form-control react-form-input"
                  id="phone_number"
                  onChange={handleChange}
                  value={values.phone_number}
                  onBlur={handleBlur}
                  placeholder="Merchant Phone"
                />
                <Error field="phone_number" />
              </div>
            </div>
            <div className="col-12 col-sm-7">
              <div className="form-group">
                <label>Profile Picture</label>
                <input
                  type="file"
                  id="file_image"
                  name="file_image"
                  ref={fileRef}
                  className="form-control react-form-input pt-2"
                  placeholder="Merchant Phone"
                  accept=".jpg,.jpeg,.png,.webp"
                  onChange={e => handleImageChange(e)}
                  onBlur={() => formik.setFieldTouched("file_image", true)}
                />
                <span className="small text-muted d-block">
                  Only allowed .jpg, .jpeg, .png, .gif, .webp
                </span>
                <Error field="file_image" />
              </div>
            </div>
            <div className="col-12 col-sm-7">
              {newImage && !errors["file_image"] ? (
                <div>
                  <img
                    src={
                      newImage
                        ? URL.createObjectURL(newImage)
                        : `${process.env.REACT_APP_UPLOAD_DIR}/${newImage}`
                    }
                    className="profile-img"
                    width={100}
                    alt="profile image"
                  />
                </div>
              ) : null}
              {oldImage && !newImage ? (
                <div>
                  <img
                    src={`${process.env.REACT_APP_UPLOAD_DIR}${oldImage}`}
                    alt="profile image"
                    className="profile-img"
                    width={100}
                  />
                </div>
              ) : null}
              {(newImage || oldImage) && !errors["file_image"] ? (
                <XCircle
                  className="image-trash-button"
                  size={20}
                  onClick={() => deleteImage(newImage ? "new" : "old")}
                ></XCircle>
              ) : null}
            </div>

            <div className="col-12 col-sm-7 text-right">
              <button type="submit" className=" btn btn-info px-5">
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
      {loading && <Loader />}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken,
    user: state.auth.user
  };
};

export default compose(
  withRouter,
  enhancer,
  connect(mapStateToProps, { success, error, setUser })
)(EditProfile);
